import { Newspaper } from "lucide-react";

export default function Masthead({ volumeDate }) {
  return (
    <header className="w-full" data-testid="masthead">
      <div className="flex items-center justify-between text-[11px] sm:text-xs font-mono uppercase tracking-[0.2em] text-ink-muted border-b border-ink pb-2">
        <span>Est. 2026 · Founded on nostalgia</span>
        <span className="hidden sm:inline">Weather · Wired · Wireless</span>
        <span>{volumeDate}</span>
      </div>
      <div className="rule-double mt-3 py-4 flex flex-col items-center text-center">
        <div className="flex items-center gap-3 mb-1">
          <Newspaper size={22} />
          <span className="font-mono text-xs uppercase tracking-[0.35em] text-ink-muted">The</span>
          <Newspaper size={22} />
        </div>
        <h1 className="font-headline font-black uppercase leading-none tracking-tighter text-[3rem] sm:text-6xl md:text-7xl lg:text-[6.5rem] text-ink">
          Time&nbsp;Capsule <span className="text-press-red">24</span>
        </h1>
        <p className="mt-3 font-mono text-[11px] sm:text-xs uppercase tracking-[0.35em] text-ink-muted">
          A daily portal · Rewind to any date since 1900
        </p>
      </div>
    </header>
  );
}
